// src/components/Header.tsx
import React from 'react';
import styled from 'styled-components';
import { Container, Button, SecondaryButton } from '../styles/layout';

const HeaderSection = styled.header`
  position: relative;
`;

const Intro = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 75vh;
  background: transparent;
`;

const Overlay = styled.div`
  padding: 140px 0 80px;
`;

const Row = styled.div`
  display: grid;
  justify-content: center;
  margin: 0 -15px;
`;

const IntroText = styled.div`
  max-width: 960px;
  padding: 0 15px;
  text-align: center;
  display: grid;
  gap: 18px;
`;

const Title = styled.h1`
  color: #1f2b3a;
  margin: 0;
`;

const TitleSpan = styled.span`
  font-weight: 500;
  color: #1c3650;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-top: 6px;
`;

const Subtitle = styled.p`
  color: #4a5a6b;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.8;
  margin: 0 auto;
`;

interface HeaderProps {
  data?: {
    title: string;
    paragraph: string;
    primaryCtaLabel?: string;
    primaryCtaHref?: string;
    secondaryCtaLabel?: string;
    secondaryCtaHref?: string;
  };
}

const Header: React.FC<HeaderProps> = (props) => {
  return (
    <HeaderSection id="header">
      <Intro>
        <Overlay>
          <Container>
            <Row>
              <IntroText>
                <Title>
                  {props.data ? props.data.title : 'Loading'}
                  <TitleSpan></TitleSpan>
                </Title>
                <Subtitle>{props.data ? props.data.paragraph : 'Loading'}</Subtitle>
                {(props.data?.primaryCtaLabel || props.data?.secondaryCtaLabel) && (
                  <ButtonRow>
                    {props.data?.primaryCtaLabel && props.data?.primaryCtaHref && (
                      <Button href={props.data.primaryCtaHref}>
                        {props.data.primaryCtaLabel}
                      </Button>
                    )}
                    {props.data?.secondaryCtaLabel && props.data?.secondaryCtaHref && (
                      <SecondaryButton href={props.data.secondaryCtaHref}>
                        {props.data.secondaryCtaLabel}
                      </SecondaryButton>
                    )}
                  </ButtonRow>
                )}
              </IntroText>
            </Row>
          </Container>
        </Overlay>
      </Intro>
    </HeaderSection>
  );
};

export default Header;
